// noinspection JSUnusedGlobalSymbols

import _ from "lodash";

import {$store} from "@isudio/globals";
import {Signup, Activation, ChangePassword, Signin, UserProfile, Brief, Contact, PrivacyPolicy, TermsOfUse, useDialogController} from "../../";

const components: any = {
  Signup: Signup,
  Activation: Activation,
  ChangePassword: ChangePassword,
  Signin: Signin,
  UserProfile: UserProfile,
  Brief: Brief,
  Contact: Contact,
  PrivacyPolicy: PrivacyPolicy,
  TermsOfUse: TermsOfUse
}

export const useOpenComponent = () => {
  const {openDialog} = useDialogController();

  return (dialogID: string, data: any = {}) => {
    let dialog = $store.App.menuItems$$.find((f: any) => f.id === dialogID);
    if (!dialog) {
      const userMenu = $store.App.menuItems$$.find((f: any) => f.id === "userMenu");
      dialog = userMenu.links.find((f: any) => f.id === dialogID);
    }
    if (!dialog) return;
    const component = components[dialog.component];

    const _props = {
      ...dialog.properties,
      ...data,
      onSuccess: () => {
        if (dialog.toastSuccessMessage) {
          const t = setTimeout(() => {
            _.toastSuccess(dialog.toastSuccessMessage);
            clearTimeout(t);
          }, 10);
        }
      }
    };

    if (dialog?.includeUser) _.set(_props, 'user', $store?.User?.user);
    if (dialog?.component === 'ChangePassword') _.set(_props, 'sendOtp', true);
    openDialog(component, _props);
  }
};
